import { render, staticRenderFns } from "./VendorContact.vue?vue&type=template&id=c4a0a42a&"
import script from "./VendorContact.vue?vue&type=script&lang=js&"
export * from "./VendorContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports